import { ActivateIcon } from '@app/icons/ActivateIcon';
import { DeactivateIcon } from '@app/icons/DeactivateIcon';
import { DeleteIcon } from '@app/icons/DeleteIcon';
import { EditIcon } from '@app/icons/EditIcon';
import { PauseIcon } from '@app/icons/PauseIcon';
import PublishIcon from '@mui/icons-material/Publish';

import { CUSTOM_ICON_TYPES } from '../../../types';

export const ActionIcon = ({ action, row }: any) => {
  const iconName = action.icon(row);

  if (CUSTOM_ICON_TYPES.EDIT === iconName) {
    return <EditIcon />;
  } else if (CUSTOM_ICON_TYPES.DELETE === iconName) {
    return <DeleteIcon />;
  } else if (CUSTOM_ICON_TYPES.PAUSE === iconName) {
    return <PauseIcon />;
  } else if (CUSTOM_ICON_TYPES.PUBLISH === iconName) {
    return <PublishIcon />;
  } else if (CUSTOM_ICON_TYPES.ACTIVATE === iconName) {
    return <ActivateIcon />;
  } else if (CUSTOM_ICON_TYPES.DEACTIVATE === iconName) {
    return <DeactivateIcon />;
  } else {
    return null;
  }
};
